import { useMemo, useState } from "react"
import ChartDimensions from "../ChartComponents/ChartDimensions/ChartDimensions"
import LineChart from "./LineChart"
import { chartsCategoriesWithLines } from "src/components/shared/Charts/constant"
import { getMarkerIntervals } from "src/components/shared/Charts/Helper/common"
import Legend from "../Components/Legend/Legend"


const CustomLineChartWrapper = (props: any) => {
    const {
        chartCategory,
        chartProps,
        data,
        ...otherProps
    } = props;
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

    const markerTypeFrequency = useMemo(() => {
        let markerTimes: any = []
        if (chartsCategoriesWithLines?.includes(chartCategory)) {
            try {
                if (otherProps?.start && otherProps?.end) {
                    const intervalDetails = getMarkerIntervals(otherProps?.start, otherProps?.end)
                    markerTimes = intervalDetails?.markerTimes || []
                }
            } catch (err) {
                console.log(err)
            }
        }
        return markerTimes
    }, [otherProps?.start, otherProps?.end, chartCategory])

    return (
        <div style={{ height: "100%", width: "100%", position: "relative", overflow: "visible" }}>
            <div style={{ height: "calc(100% - 50px)" }}>
                <ChartDimensions setDimensions={setDimensions}>
                    <LineChart
                        {...otherProps}
                        chartCategory={chartCategory}
                        width={dimensions?.width}
                        height={dimensions?.height}
                        chartProps={chartProps}
                        data={data}
                        markerTypeFrequency={markerTypeFrequency}
                    />
                </ChartDimensions>
            </div>
            <div style={{ width: "100%", height: "50px", display: "flex", overflowX: "auto", padding: "10px", whiteSpace: "nowrap" }}>
                {Object.keys(chartProps?.legends || {})?.map((key) => {
                    const legend = chartProps?.legends?.[key];
                    return <Legend key={key} legend={legend} />
                })}
            </div>
        </div>
    )
}

export default CustomLineChartWrapper